import React from 'react';
import visualization from './visualization';
import Visualization from '../index';

function BuChart01(props) {
  return (
    <Visualization
      className={props.className}
      viz={visualization}
      id={props.id}
      height={props.height}
      data={props.data}
      menuOffset={props.menuOffset}
      unit={props.unit}
    />
  );
}

export default BuChart01;
